const subTypes = [
    {
        id: 1,
        pt: "Produtor",
        en: "Producer",
        value: "PRODUCER"
    },
    {
        id: 2,
        pt: "Estudante",
        en: "Student",
        value: "STUDENT"
    },
    {
        id: 3,
        pt: "Consultor",
        en: "Consultant",
        value: "CONSULTANT"
    },
    {
        id: 4,
        pt: "Pesquisador",
        en: "Researcher",
        value: "RESEARCHER"
    },
    {
        id: 5,
        pt: "Outros",
        en: "Other",
        value: "OTHER"
    }
]

export default subTypes;